import React from 'react';

interface CustomDotProps {
  cx?: number;
  cy?: number;
  stroke?: string;
  r?: number;
  fillColor?: string;
  fillSize?: number;
  borderColor?: string;
  borderSize?: number;
  paddingColor?: string;
  paddingSize?: number;
}

export const CustomDot: React.FC<CustomDotProps> = ({ cx, cy, fillColor, borderColor = "#DEDFE4", paddingColor = "white", fillSize = 4, borderSize = 7, paddingSize = 6 }) => {
  return (
    <g>
      {/* Gray outer border */}
      <circle cx={cx} cy={cy} r={borderSize} fill={borderColor} />
      {/* White padding */}
      <circle cx={cx} cy={cy} r={paddingSize} fill={paddingColor} />
      {/* Colored inner circle */}
      <circle cx={cx} cy={cy} r={fillSize} fill={fillColor} />
    </g>
  );
};

export const CustomActiveDot: React.FC<CustomDotProps> = ({ cx, cy, fillColor, borderColor, paddingColor = "white", fillSize = 4, borderSize = 8, paddingSize = 7 }) => {
  return (
    <g>
      {/* Gray outer border */}
      <circle cx={cx} cy={cy} r={borderSize} fill={!borderColor ? fillColor : borderColor} />
      {/* White padding */}
      <circle cx={cx} cy={cy} r={paddingSize} fill={paddingColor} />
      {/* Colored inner circle */}
      <circle cx={cx} cy={cy} r={fillSize} fill={fillColor} />
    </g>
  );
};

